import { fnv1aHash } from './fnv1a-hash';

type ABExperimentGroup = 'control' | 'test';

/**
 * Splits userIds into two deterministic group assignments with a roughly even 50/50 distribution (statistically over many users)
 */
export function getABExperimentGroup(expName: string, userId: string, allocation = 0.5): ABExperimentGroup {
  const hash = fnv1aHash(`${expName}:${userId}`); // including the expName makes it so that a user can be in different groups for different experiments
  const bucket = hash % 10_000;
  return bucket < allocation * 10_000 ? 'test' : 'control';
}

/**
 * Non-deterministic random group assignment. This requires no user context and will change every time it's called.
 * This only works for non-visual experiments, like performance experiments that don't measure user interactions.
 */
export function getRandomABExperimentGroup(allocation = 0.5): ABExperimentGroup {
  return Math.random() < allocation ? 'test' : 'control';
}
